import * as React from 'react';

const UpskillIcon = () => (
  <svg role="presentation" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="24" fill="#F5F7F8" />
    <g clipPath="url(#UpskillIconA)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.716 19.213v-7.182h.71v8.396h-8.395v-.711h7.182L9.78 12.282l.503-.502 7.434 7.433z"
        fill="#1F1F1F"
      />
    </g>
    <g clipPath="url(#UpskillIconB)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.787 19.716h7.182v.71h-8.396v-8.395h.711v7.182l7.434-7.434.502.503-7.433 7.434z"
        fill="#1F1F1F"
      />
    </g>
    <g clipPath="url(#UpskillIconC)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.213 29.442h-7.182v-.711h8.396v8.396h-.711v-7.183l-7.434 7.434-.502-.503 7.433-7.433z"
        fill="#1F1F1F"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.284 29.947v7.182h-.71v-8.395h8.395v.71h-7.182l7.434 7.434-.503.502-7.434-7.433z"
      fill="#1F1F1F"
    />
    <circle cx="23.9" cy="24.479" r="3.764" fill="#fff" stroke="#1F1F1F" />
    <defs>
      <clipPath id="UpskillIconA">
        <path fill="#fff" transform="rotate(45 -.218 19.961)" d="M0 0h14.214v14.214H0z" />
      </clipPath>
      <clipPath id="UpskillIconB">
        <path fill="#fff" transform="rotate(135 18.675 17.138)" d="M0 0h14.214v14.214H0z" />
      </clipPath>
      <clipPath id="UpskillIconC">
        <path fill="#fff" transform="rotate(-45 41.963 11.724)" d="M0 0h14.214v14.214H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default UpskillIcon;
